module.exports = require("./Partners")
